import { Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl5')} ${spacing('md')} 0 ${spacing('md')};
`;

export const StyledHeader = styled.div`
  text-align: center;
  max-width: 58rem;
  margin: auto;
  line-height: 1.5;
  margin-bottom: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledFeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('mdlg')};
  margin-bottom: ${spacing('xl4')};

  @media (min-width: ${screen('lg')}) {
    gap: ${spacing('xl')};
  }
`;

export const StyledFeatureImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing('md')} ${spacing('md')} 0;

  @media (min-width: ${screen('lg')}) {
    justify-content: flex-start;
    padding: 0;
  }

  img {
    display: block;

    &.desktop {
      display: none;
    }

    @media (min-width: ${screen('lg')}) {
      width: 100%;

      &.mobile {
        display: none;
      }
      &.desktop {
        display: block;
      }
    }
  }
`;

export const StyledFeatureContent = styled.div`
  padding: 0 ${spacing('mdlg')} ${spacing('mdlg')};

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('xl2')} ${spacing('xl2')} ${spacing('xl2')} 0;
  }

  ${Heading3} {
    margin-top: ${spacing('md')};
  }
`;

export const StyledFeature = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing('md')};
  background-color: ${color('white')};
  border-radius: ${radius('lg')};
  box-shadow: ${shadow('md')};
  overflow: hidden;

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: ${spacing('xl')};
    font-size: ${fontSize('lg')};

    &:nth-of-type(odd) {
      ${StyledFeatureImage} {
        @media (min-width: ${screen('lg')}) {
          order: 1;
          justify-content: flex-end;
        }
      }

      ${StyledFeatureContent} {
        @media (min-width: ${screen('lg')}) {
          padding: ${spacing('xl2')} 0 ${spacing('xl2')} ${spacing('xl2')};
        }
      }
    }
  }
`;

export const StyledStep = styled.div`
  font-size: ${fontSize('lg')};
  display: flex;
  flex-direction: column-reverse;
  gap: 0rem;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    gap: 2rem;
  }

  > div {
    flex: 1 1 auto;
  }

  > div:first-child {
    flex: 1 0 50%;
  }

  li {
    list-style-type: disc;
    margin-left: 1.5rem;
  }

  img {
    max-width: 80%;
    height: auto;
    margin: 2rem auto;
    display: block;
  }

  display: flex;
`;

export const StyledCta = styled.div`
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing('xl4')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    margin-bottom: ${spacing('md')};
  }

  p {
    line-height: 1.5;
    color: ${color('text_subtle')};
    margin-top: ${spacing('xs')};

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('lg')};
      line-height: 1.6;
    }
  }
`;
